import { userHasPermission } from './userPermissions'

export function toNumber(value) {
  if (value === null || value === undefined || value === '') {
    return 0
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }

  const raw = String(value).trim().replace(/\s/g, '')

  const normalized = /^-?\d+[.,]\d{1,2}$/.test(raw)
    ? raw.replace(',', '.')
    : raw.replace(/\./g, '').replace(',', '.')

  const sanitized = normalized.replace(/[^\d.-]/g, '')

  const parsed = Number(sanitized)
  return Number.isFinite(parsed) ? parsed : 0
}

export function parseCurrencyBRL(value) {
  return toNumber(value)
}

export function formatCurrencyBRL(value) {
  return Number(toNumber(value)).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}

export function getReceivableAmounts(conta = {}) {
  const original = toNumber(conta.valor_receber)
  const receivedFromField = toNumber(conta.valor_recebido)
  const receivedFromHistory = Array.isArray(conta.baixas)
    ? conta.baixas.reduce((total, baixa) => total + toNumber(baixa?.valor_recebido ?? baixa?.valor), 0)
    : 0
  const received = receivedFromField > 0 ? receivedFromField : receivedFromHistory
  const saldoFromField = conta.saldo_restante
  const saldo =
    saldoFromField !== null && saldoFromField !== undefined
      ? toNumber(saldoFromField)
      : Math.max(original - received, 0)

  return {
    original,
    received,
    saldo
  }
}

export function isPartialReceivable(conta = {}) {
  const amounts = getReceivableAmounts(conta)
  return Number(conta.status) === 0 && amounts.received > 0 && amounts.saldo > 0
}

export function resolveReceivableStatus(conta = {}) {
  const amounts = getReceivableAmounts(conta)

  if (Number(conta.status) === 1 || (amounts.saldo <= 0 && amounts.received > 0)) {
    return {
      label: 'Quitado',
      variant: 'success',
      icon: 'ri-checkbox-circle-line',
      textClass: 'text-white'
    }
  }

  if (amounts.received > 0) {
    return {
      label: 'Parcialmente recebido',
      variant: 'warning',
      icon: 'ri-time-line',
      textClass: 'text-dark'
    }
  }

  return {
    label: 'Em aberto',
    variant: 'danger',
    icon: 'ri-alert-line',
    textClass: 'text-white'
  }
}

export function canRegisterReceivablePartial(user) {
  if (!user) {
    return false
  }

  const roles = Array.isArray(user.roles) ? user.roles : []
  if (
    roles.some((role) => {
      const name = String(role?.name || '').toLowerCase()
      return name === 'super' || name === 'admin'
    })
  ) {
    return true
  }

  return userHasPermission(user, 'conta-receber.edit')
}
